export default __webpack_public_path__ + "static/media/pdf_thumbnail_paper.dffa5f77.jpg";